'use client';

import NavAcessibilidade from '@/components/NavAcessibilidade/NavAcessibilidade';
import Menu from '@/components/Menu/Menu';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import Footer from '@/components/Footer/Footer';
import Newsletter from '@/components/Newsletter/Newsletter';
import JornadadeAprendizagem from '@/components/JornadadeAprendizagem/JornadadeAprendizagem';
import styles from './NossoAcervo.module.css';
import classNames from 'classnames';
import Button from '@/components/Button/Button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/swiper.css';
import { useState, useEffect } from 'react';
import useGetPublicacoes from "@/hooks/requestQueries/nossoAcervo/getPublicacoes";
import useGetCategorias from "@/hooks/requestQueries/nossoAcervo/getCategorias";
import useGetSubcategorias from "@/hooks/requestQueries/nossoAcervo/getSubcategorias";
import useGetEditoras from "@/hooks/requestQueries/nossoAcervo/getEditoras";
import { useSearchParams } from 'next/navigation';
import Link from "next/link";
import CustomSelect, { OptionType } from '@/components/CustomSelect/CustomSelect';
import { slugifyTitulo } from "@/utils/slugify";

function NossoAcervoView() {

    const searchParams = useSearchParams();
    const produtoId = searchParams.get('produtoId') ?? '1' as any;
    const searchFromUrl = searchParams.get('search') ?? '';

    const [searchTerm, setSearchTerm] = useState(searchFromUrl);

    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchFromUrl);
    const [page, setPage] = useState(1);
    const [allPublicacoes, setAllPublicacoes] = useState<any[]>([]);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [loadedImages, setLoadedImages] = useState<{ [key: number]: boolean }>({});
    const [ordenacao, setOrdenacao] = useState(2);

    const [selectedCategorias, setSelectedCategorias] = useState<OptionType[]>([]);
    const [selectedSubcategorias, setSelectedSubcategorias] = useState<OptionType[]>([]);
    const [selectedEditoras, setSelectedEditoras] = useState<OptionType[]>([]);


    const { data: categoriasData } = useGetCategorias(produtoId);
    const { data: subcategoriasData } = useGetSubcategorias(selectedCategorias.map(c => c.value), produtoId);
    const { data: editorasData } = useGetEditoras(produtoId);

    const categoriasOptions = categoriasData?.data.map((c: { id: number; nome: string; }) => ({ value: c.id, label: c.nome })) || [];
    const subcategoriasOptions = subcategoriasData?.data.map((s: { id: number; nome: string; }) => ({ value: s.id, label: s.nome })) || [];
    const editorasOptions = editorasData?.data.map((e: { id: number; nome: string; }) => ({ value: e.id, label: e.nome })) || [];

    const { data: publicacoesData, isLoading, isError } = useGetPublicacoes(
        debouncedSearchTerm,
        selectedCategorias.map(c => c.value),
        selectedSubcategorias.map(s => s.value),
        selectedEditoras.map(e => e.value),
        [],
        ordenacao,
        page,
        10,
        produtoId
    );

    const handleImageLoad = (id: number) => {
        setLoadedImages((prev) => ({ ...prev, [id]: true }));
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    useEffect(() => {
        if (publicacoesData?.data.resultadoPaginado) {
            setAllPublicacoes((prev) => {
                if (page === 1) {
                    return publicacoesData.data.resultadoPaginado;
                }
                const newPublicacoes = publicacoesData.data.resultadoPaginado.filter(
                    (newPub: { id: number }) => !prev.some((publicacao) => publicacao.id === newPub.id)
                );
                return [...prev, ...newPublicacoes];
            });
            setIsLoadingMore(false);
        }
    }, [publicacoesData, page]);

    useEffect(() => {
    const searchFromUrl = searchParams.get('search') ?? '';
    if (searchFromUrl) {
        setSearchTerm(searchFromUrl);
        setDebouncedSearchTerm(searchFromUrl);
    }
}, [searchParams]);

    useEffect(() => {
        setAllPublicacoes([]);
        setPage(1);
    }, [debouncedSearchTerm]);

    const options: OptionType[] = [
        { value: 0, label: 'Ordenar por' },
        { value: 1, label: 'Melhor avaliados' },
        { value: 6, label: 'Mais avaliados' },
        { value: 2, label: 'Mais novos' },
        { value: 3, label: 'Mais antigos' },
        { value: 4, label: 'Título A-Z' },
        { value: 5, label: 'Título Z-A' },
    ];

    const [direction1, setDirection1] = useState<'left' | 'right'>('right');
    const [direction2, setDirection2] = useState<'left' | 'right'>('left');
    const [direction3, setDirection3] = useState<'left' | 'right'>('right');

    useEffect(() => {
        const interval = setInterval(() => {
            setDirection1((prev) => (prev === 'right' ? 'left' : 'right'));
            setDirection2((prev) => (prev === 'left' ? 'right' : 'left'));
            setDirection3((prev) => (prev === 'right' ? 'left' : 'right'));
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const getSwiperConfig = (direction: 'left' | 'right') => ({
        modules: [Autoplay],
        slidesPerView: 'auto' as const,
        spaceBetween: 0,
        loop: true,
        speed: 15000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: direction === 'left',
        },
    }); 

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    return (
        
        <div>
            <NavAcessibilidade />
            <Menu />
            <div id="conteudo"></div>
            <Breadcrumb titulo="Nosso Acervo" color="blue200" />

            <section className={styles.nossoAcervo}>
                <div className={styles.carouselBooks}>
                    <div className="containerBooks">
                        <Swiper {...getSwiperConfig(direction1)} className={styles.rowAcervo}>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-01.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-02.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-03.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-04.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-05.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-06.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-07.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-08.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-09.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-10.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-11.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-12.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-13.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-14.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-15.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-16.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-17.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-18.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-19.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-20.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-21.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-22.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-23.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-24.jpg" alt="" />
                            </SwiperSlide>
                        </Swiper>

                        <Swiper {...getSwiperConfig(direction2)} className={styles.rowAcervo}>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-25.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-26.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-27.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-28.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-29.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-30.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-31.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-32.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-33.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-34.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-35.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-36.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-37.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-38.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-39.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-40.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-41.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-42.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-43.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-44.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-45.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-46.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-47.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-48.jpg" alt="" />
                            </SwiperSlide>
                        </Swiper>

                        <Swiper {...getSwiperConfig(direction3)} className={styles.rowAcervo}>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-49.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-50.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-51.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-52.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-53.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-54.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-55.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-56.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-57.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-58.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-59.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-60.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-61.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-62.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-63.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-64.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-65.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-66.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-67.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-68.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-69.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-70.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-71.jpg" alt="" />
                            </SwiperSlide>
                            <SwiperSlide className={styles.itemAcervoBook}>
                                <img loading="lazy" src="/images/nossoacervo/img-acervo-72.jpg" alt="" />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>

                <div className={styles.filterAcervo}>
                    <div className={styles.filterAcervo}>
                        <div className={styles.uiContainer}>
                            <div className={styles.headerAcervo}>
                                <h2 className={styles.title} tabIndex={0}>Títulos relevantes e autores renomados. Inserção de novas obras todo mês.</h2>
                            </div>

                            <form id='searchAcervo'>
                                <div className={styles.Search}>
                                    <input
                                        className={styles.inputSearch}
                                        type="text"
                                        placeholder="Digite o nome do livro ou do autor(a) que deseja buscar"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                    />
                                    <img tabIndex={0} src="/images/btn-search-acervo.png" className={styles.btnSearch} alt="Ícone Lupa" aria-label="Ícone Lupa" loading='lazy' />
                                </div>

                                <div className={styles.filter}>
                                    <div>
                                        <CustomSelect
                                        instanceId="Categorias"
                                        isMulti={true}
                                        options={categoriasOptions}
                                        value={selectedCategorias}
                                        onChange={(selected) => {
                                            setSelectedCategorias(Array.isArray(selected) ? selected : selected ? [selected] : []);
                                            setSelectedSubcategorias([]);
                                            setPage(1);
                                            setAllPublicacoes([]);
                                        }}
                                        placeholder="Categoria"
                                            isSearchable={true}
                                        />
                                    </div>

                                    <div>
                                        <CustomSelect
                                        instanceId="subCategorias"
                                        isMulti={true}
                                        options={subcategoriasOptions}
                                        value={selectedSubcategorias}
                                        onChange={(selected) => {
                                            setSelectedSubcategorias(Array.isArray(selected) ? selected : selected ? [selected] : []);
                                            setPage(1);
                                            setAllPublicacoes([]);
                                        }}
                                        placeholder="Subcategoria"
                                        isDisabled={selectedCategorias.length === 0}
                                            isSearchable={true}
                                        />
                                    </div>

                                    <div>
                                        <CustomSelect
                                        instanceId="Editoras"
                                        isMulti={true}
                                        options={editorasOptions}
                                        value={selectedEditoras}
                                        onChange={(selected) => {
                                            setSelectedEditoras(Array.isArray(selected) ? selected : selected ? [selected] : []);
                                            setPage(1);
                                            setAllPublicacoes([]);
                                        }}
                                        placeholder="Editora"
                                            isSearchable={true}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.acervoListagemInformacoes}>
                <div className={styles.uiContainer}>
                    <div className={styles.acervoList}>
                        <div>
                            <p tabIndex={0}>
                                Exibindo {
                                    allPublicacoes.length > 0
                                    ? `${((page - 1) * 10 + 1).toLocaleString()} - ${Math.min(page * 10, publicacoesData?.data.quantidade || 0).toLocaleString()}`
                                    : "0"
                                } de {(publicacoesData?.data.quantidade || 0).toLocaleString()} livro(s)
                            </p>
                        </div>
                        <div className={styles.acervoOrder}>
                             <CustomSelect
                                instanceId="ordenacao"
                                isMulti={false}
                                options={options}
                                value={options.find((opt) => opt.value === ordenacao) || null}
                                onChange={(selectedOption) => {
                                    if (selectedOption && !Array.isArray(selectedOption)) {
                                    setOrdenacao(selectedOption.value);
                                    setPage(1);
                                    setAllPublicacoes([]);
                                    }
                                }}
                                placeholder="Melhor Avaliados"
                                isSearchable={true}
                                className={styles.inputSearch}
                                />
                        </div>
                    </div>

                    <div className={styles.containerAcervo}>
                        {isLoading ? (
                            <p></p>
                        ) : isError ? (
                            <p>Erro ao carregar as publicações.</p>
                        ) : allPublicacoes.length > 0 ? (
                            allPublicacoes.map((publicacao) => (
                                <Link
                                    key={publicacao.id}
                                    href={{
                                        pathname: `/NossoAcervo/Publicacao/${slugifyTitulo(publicacao.titulo)}-${publicacao.id}`
                                    }}
                                    className={styles.itemAcervo}
                                    aria-label={`Ver detalhes do livro ${publicacao.titulo} por ${publicacao.autores}`}
                                >
                                    <article>
                                        <div className={styles.acervoImagemEFlags}>
                                            <div className={styles.imgAcervo}>
                                                <img
                                                    tabIndex={0}
                                                    src={`${publicacao.capa}`}
                                                    alt={`Capa do livro ${publicacao.titulo}`}
                                                    loading="lazy"
                                                    width={222}
                                                    height={330}
                                                    onError={(e) => (e.currentTarget.src = '/images/book_default.jpg')}
                                                    onLoad={() => handleImageLoad(publicacao.id)}
                                                />
                                            </div>
                                            {loadedImages[publicacao.id] && (
                                                <div className={styles.containerImgFlags}>
                                                    
                                                    {publicacao.possuiPdf && (
                                                        <div className={classNames(styles.itemFlag, styles.pdf)}>PDF</div>
                                                    )}
                                                    {publicacao.possuiEpub && (
                                                        <div className={classNames(styles.itemFlag, styles.epub)}>Epub</div>
                                                    )}
                                                    {publicacao.novo && (
                                                        <div className={classNames(styles.itemFlag, styles.novo)}>Novo</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div className={styles.contentAcervo}>
                                            <h3 tabIndex={0} className={styles.tituloLivro} title={publicacao.titulo}>{publicacao.tituloEncurtado}</h3>
                                            <p tabIndex={0} className={styles.autorLivro} title={publicacao.autoresCompleto}>{publicacao.autoresEncurtado}</p>
                                        </div>
                                    </article>
                                </Link>
                            ))
                        ) : (
                            <p tabIndex={0} className={styles.noResults}>Nenhuma publicação encontrada.</p>
                        )}
                    </div>

                    <div className={styles.carregarMais}>
                        {publicacoesData?.data.resultadoPaginado.length === 10 && allPublicacoes.length < publicacoesData?.data.quantidade && (
                            <Button
                                text={isLoadingMore ? "Carregando..." : "Carregar mais livros"}
                                arialabel="Carregar mais livros"
                                className="btnPadraoCarregarMais"
                                onClick={() => {
                                    setIsLoadingMore(true);
                                    setPage((prevPage) => prevPage + 1);
                                }}
                                scrollToTop={false}
                                disabled={isLoadingMore}
                            />
                        )}
                    </div>
                </div>
            </section>

            <JornadadeAprendizagem />
            <Newsletter />
            <Footer />
        </div>
    );
}

export default NossoAcervoView;